import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

/**
 * StandardLayout — shared shell for auxiliary pages (About, Contact, etc.)
 * Uses the same max-w-6xl structural column with border-l/border-r as the Home page,
 * so all content aligns to the same vertical grid axis.
 */
export function StandardLayout({ children }) {
    return (
        <div className="bg-[#09090b] min-h-screen">
            {/* ── Structural Column — continuous vertical border lines ── */}
            <div className="max-w-6xl mx-auto min-h-screen flex flex-col">
                <Navbar />
                <main className="flex-1 pt-16">
                    {children}
                </main>
                <Footer />
            </div>
        </div>
    );
}
